import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useRef } from 'react';
import { getFilesFromInputChangeEvent } from '../../../../utils/input-utils';
import { Button as ButtonComponent, ButtonColor } from '../../../button';
import { DisplayText } from '../../../display-text';
import { FileDropzone } from '../../../file-dropzone/file-dropzone';
import { Icon } from '../../../icon';
export var FileInputMode;
(function (FileInputMode) {
    FileInputMode["Button"] = "Button";
    FileInputMode["Dropzone"] = "Dropzone";
})(FileInputMode || (FileInputMode = {}));
export var FileInputFileType;
(function (FileInputFileType) {
    FileInputFileType["Image"] = "image/*";
})(FileInputFileType || (FileInputFileType = {}));
const b = bemClassBuilder('v-file-input');
export const FileInput = observer(props => {
    const { mode, fileType, multiple, onFilesChanged } = props;
    const handleFilesChanged = (event) => {
        const files = getFilesFromInputChangeEvent(event);
        onFilesChanged(files);
    };
    const inputRef = useRef(null);
    const handleBrowseClick = (event) => {
        var _a;
        event.preventDefault();
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    return (_jsxs("div", Object.assign({ className: b.block({ mode: mode }) }, { children: [props.mode === FileInputMode.Dropzone && (_jsx(FileDropzone, Object.assign({ fileType: fileType, multiple: multiple, activeDragIconName: props.dropzoneActiveDragIconName, inputRef: inputRef, onFilesChanged: onFilesChanged }, { children: _jsxs("div", Object.assign({ className: b.element('dropzone-content') }, { children: [_jsx(Icon, { className: b.element('dropzone-icon'), name: props.dropzonePromptIconName }), _jsx(DisplayText, { label: props.dropzonePromptMessage }), _jsx(ButtonComponent, Object.assign({ iconOnly: true, color: ButtonColor.Tertiary, className: b.element('browse-text'), onClick: handleBrowseClick }, { children: props.browseButtonLabel }))] })) }))), props.mode === FileInputMode.Button && (_jsxs(_Fragment, { children: [_jsx("input", { type: "file", accept: fileType, onChange: handleFilesChanged, ref: inputRef, multiple: multiple }), _jsx(ButtonComponent, Object.assign({ className: b.element('browse-button'), onClick: handleBrowseClick }, { children: props.browseButtonLabel }))] }))] })));
});
FileInput.displayName = 'FileInput';
